import { XCircleIcon } from "@heroicons/react/solid"
import { SVGProps } from "react"

export default (props: SVGProps<SVGSVGElement>) => {
    return (
        <XCircleIcon {...props}/>
    )
}